import axios from "../../axios";
import React, { useState, useEffect } from "react";
import { BiLock, BiLogoSlack } from "react-icons/bi";
import { connect } from "react-redux";
import * as actionCreators from "../../modules/actions";
import { BsShare } from "react-icons/bs";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  UncontrolledAlert,
} from "reactstrap";
import { SlLayers } from "react-icons/sl";
import { getSlackChannels, getTeamsChannels } from "../../utils/url";
import { data } from "jquery";
import { serverAuthBaseUrl, Spinner } from "../../utils/constants";
import InitialLinkButton from "./InitialLinkButton";
import {AiFillCloseCircle} from "react-icons/ai"

function SlackSharePopup({
  handleSocialShare,
  slackShared = [],
  answer,
  orgId,
  userId,
  setShowSlackPopup,
  organization,
  setReturnUrlAfterSlackTeamsAuth,
}) {
  const [slackChannels, setSlackChannels] = useState([]);
  const [channelsLoading, setChannelsLoading] = useState(false);
  const redirectUrl = serverAuthBaseUrl() + "public/slack-auth";
  const [sharedId, setSharedId] = useState([]);
  const [error, setError] = useState(null);
  const [anonymousShared, setAnonymousShared] = useState(false);

  useEffect(() => {
    setChannelsLoading(true);

    axios
      .get(getSlackChannels)
      .then(({ data }) => {
        setChannelsLoading(false);
        console.log(data.data);
        setSlackChannels([...data.data]);
      })
      .catch((err) => {
        setChannelsLoading(false);
        console.log(err);
      });
  }, []);

  return (
    <Modal
      isOpen={true}
      className="dashboardModalContainer dashboardModalDetailsContainer"
    >
      <ModalHeader
        toggle={() => setShowSlackPopup(false)}
        className="slack_team_share_header"
        close={<AiFillCloseCircle color="white" onClick={() => setShowSlackPopup(false)}  size={25}/>}
        
      >
        <div className="dashboardModalTitle">Select Slack Channels</div>
     
      </ModalHeader>

      <ModalBody className={"dani-channel-modal"}>
        {channelsLoading ? (
          <img src={Spinner} className="spinner-pos" />
        ) : (
          <div>
            {organization &&
            organization.allowedSlackWorkspaces &&
            organization.allowedSlackWorkspaces.length > 0 ? (
              <div>
                {slackChannels.length ==0  ? (
                  <div className={"text-center"}>
                    <InitialLinkButton iconComp={<BiLogoSlack color="white" size={22} />} text={"Connect Slack"} onClick={()=>{
                       setReturnUrlAfterSlackTeamsAuth(window.location.pathname);
                      window.open(`https://slack.com/oauth/v2/authorize?client_id=340811567938.6246713050436&scope=chat:write,chat:write.public,incoming-webhook,channels:read,groups:read,im:read,mpim:read,app_mentions:read,users:read,users:write,im:write,im:history,im:write.topic,groups:write,mpim:write,usergroups:read,channels:manage&user_scope=channels:read,im:read,mpim:read,groups:read,users:read&state=${orgId}_${userId}&redirect_uri=${encodeURIComponent(
                        redirectUrl
                      )}`);

                    }} type="SLACK" />
                  </div>
                ) : (
                  <a
                    className="float-right"
                    href={`https://slack.com/oauth/v2/authorize?client_id=340811567938.6246713050436&scope=chat:write,chat:write.public,incoming-webhook,channels:read,groups:read,im:read,mpim:read,app_mentions:read,users:read,users:write,im:write,im:history,im:write.topic,groups:write,mpim:write,usergroups:read,channels:manage&user_scope=channels:read,im:read,mpim:read,groups:read,users:read&state=${orgId}_${userId}&redirect_uri=${encodeURIComponent(
                      redirectUrl
                    )}`}
                    target="_blank"
                    onClick={() => {
                      setReturnUrlAfterSlackTeamsAuth(window.location.pathname);
                    }}
                    style={{position:"absolute",right:"1rem"}}
                  >
                    <img
                      alt="Add to Slack"
                      height="40"
                      width="139"
                      src="https://platform.slack-edge.com/img/add_to_slack.png"
                      srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
                    />
                  </a>
                )}
              </div>
            ) : (
              ""
            )}

            {channelsLoading ? (
              <img src={Spinner} className="spinner-pos" />
            ) : slackChannels.length > 0 ? (
              <div>
                <Alert
                  isOpen={error}
                  toggle={() => setError(null)}
                  color="danger"
                >
                  {error}
                </Alert>

                {slackChannels.map((wp) => {
                  return (
                    <div className="my-4">
                      <h5 className="pt-2">Workspace : {wp.workSpaceName}</h5>
                      <div className="fixTableHead">
                        <table>
                          <thead>
                            <tr>
                              <th style={{ width: "40%" }}>Channel Name</th>
                              {/* <th style={{ width: "10%" }}>Members</th> */}
                              <th style={{ width: "40%" }}>Share</th>
                            </tr>
                          </thead>
                          <tbody>
                            {wp.channels.length === 0 && (
                              <span>No channels added</span>
                            )}
                            {wp.channels.map((item, index) => {
                              const isShared = slackShared.length
                                ? slackShared.includes(item.id)
                                : sharedId.find((x) => x.id === item.id);
                              return (
                                <tr
                                  className={`dani-slack-channel-row${index}`}
                                >
                                  <td style={{ width: "40%" }}>{item.name}</td>
                                  {/* <td style={{ width: "10%" }}>
                                  {item.num_members}
                                </td> */}
                                  <td
                                    style={{ width: "40%" }}
                                    className={
                                      !isShared
                                        ? "dani-slack-popup-shareBtn"
                                        : `dani-slack-popup-shareBtn_full${
                                            isShared.anonymousShared
                                              ? " anonymous"
                                              : ""
                                          }`
                                    }
                                  >
                                    {" "}
                                    {isShared ? (
                                      <span
                                        className={
                                          isShared.anonymousShared
                                            ? "shared_succ_chipp_anonymous"
                                            : "shared_succ_chipp"
                                        }
                                      >
                                        Shared Successfully!
                                      </span>
                                    ) : (
                                      <span>
                                        <Button
                                          color="info"
                                          onClick={() =>
                                            handleSocialShare({
                                              type: "SLACK",
                                              channelId: item.id,
                                              channelName:
                                                item.user === true
                                                  ? item.id
                                                  : item.name,
                                              workSpaceId: wp.workSpaceId,
                                              answer,
                                            })
                                              .then((data) => {
                                                setSharedId([
                                                  ...sharedId,
                                                  {
                                                    id: data,
                                                    anonymousShared: false,
                                                  },
                                                ]);
                                              })
                                              .catch((err) => {
                                                setError(err);
                                              })
                                          }
                                        >
                                          Share <BsShare />{" "}
                                        </Button>

                                        <Button
                                          // color="info"
                                          className="dani-slack-chat-anonymous"
                                          onClick={() =>
                                            handleSocialShare({
                                              type: "SLACK",
                                              channelId: item.id,
                                              channelName: item.name,
                                              workSpaceId: wp.workSpaceId,
                                              isAnonymous: true,
                                              answer,
                                            })
                                              .then((data) => {
                                                setSharedId([
                                                  ...sharedId,
                                                  {
                                                    id: data,
                                                    anonymousShared: true,
                                                  },
                                                ]);
                                              })
                                              .catch((err) => {
                                                setError(err);
                                              })
                                          }
                                        >
                                          Share anonymously
                                          <BsShare />{" "}
                                        </Button>
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              ""
            )}
          </div>
        )}
      </ModalBody>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    setReturnUrlAfterSlackTeamsAuth: (data) =>
      dispatch(actionCreators.setReturnUrlAfterSlackTeamsAuth(data)),
  };
};

export default connect(null, mapDispatchToProps)(SlackSharePopup);
